export default "__VITE_ASSET__C1UwQso5__"